export default __webpack_public_path__ + "static/valve_b.54c2c469427f5d86a50b031ab21ea2c1.svg";